import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  showUrgency?: boolean;
}
export function App({
  showUrgency = true
}: AppProps) {
  useMetaPixel();
  return <div className="w-full bg-white font-sans text-neutral-800 antialiased" data-id="element-0" data-mp="2wiyy8vkq9zd9">
      <main data-id="element-1" data-mp="28tw6guwdqq51">
        <Hero data-id="element-2" data-mp="28tmdqzjya4vn" />
        <Problem data-id="element-3" data-mp="28t4lee0esat0" />
        <Solution data-id="element-4" data-mp="28sl3uyeo7ofi" />
        <WhatYouGet data-id="element-5" data-mp="28s2xh8yanttv" />
        <Bonuses data-id="element-6" data-mp="23vkuadim43jn" />
        <Pricing showUrgency={showUrgency} data-id="element-7" data-mp="23w4ey1znd61d" />
        <Testimonials data-id="element-8" data-mp="23t8i6gzjcnei" />
        <Guarantee data-id="element-9" data-mp="3ijxoypkvdyjd" />
        <Faq data-id="element-10" data-mp="3ikh5q2ysagvt" />
        <FinalCta showUrgency={showUrgency} data-id="element-11" data-mp="3iiwfgpji5k3r" />
      </main>
      <Footer data-id="element-12" data-mp="3mlj8gtrwtb2j" />
    </div>;
}